module.exports = "/_next/static/images/93fe73bcbee808cbf79f90b3c9ca2248-phone-and-card@xs-2x.jpg.webp";